module.exports = __webpack_public_path__ + "static/img/spread-center.781ff4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/spread-center.jpg
// module id = gRi2
// module chunks = 1